import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/players'
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/players',
    name: 'Players',
    component: () => import('../views/Player.vue')
  },
  {
    path: '/teams',
    name: 'Teams',
    component: () => import('../views/Teams.vue')
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue')
  },
  {
    path: '/naughtylist',
    name: 'NaughtyList',
    component: () => import('../views/NaughtyListPrint.vue')
  },
  // CPPS CMS
  {
    path: '/cpps/news',
    name: 'CppsNews',
    component: () => import('../views/cpps/CppsNewsManager.vue')
  },
  {
    path: '/cpps/faq',
    name: 'CppsFaq',
    component: () => import('../views/cpps/CppsFaqManager.vue')
  },
  {
    path: '/cpps/prices',
    name: 'CppsPrices',
    component: () => import('../views/cpps/CppsPricesManager.vue')
  },
  {
    path: '/cpps/events',
    name: 'CppsEvents',
    component: () => import('../views/cpps/CppsEventsManager.vue')
  },
  {
    path: '/cpps/rules',
    name: 'CppsRules',
    component: () => import('../views/cpps/CppsRulesManager.vue')
  },
  {
    path: '/cpps/markers',
    name: 'CppsMarkers',
    component: () => import('../views/cpps/CppsMarkersManager.vue')
  },
  {
    path: '/cpps/scores',
    name: 'CppsScoreEntry',
    component: () => import('../views/cpps/CppsScoreEntry.vue')
  },
  {
    path: '/cpps/training',
    name: 'CppsTrainingManager',
    component: () => import('../views/cpps/CppsTrainingManager.vue')
  },
  {
    path: '/cpps/roundsetup',
    name: 'CppsRoundSetup',
    component: () => import('../views/cpps/CppsRoundSetup.vue')
  },
  {
    path: '/cpps/new-team',
    name: 'CppsNewTeam',
    component: () => import('../views/cpps/CppsNewTeam.vue')
  },
  {
    path: '/cpps/roundactions',
    name: 'CppsRoundActions',
    component: () => import('../views/cpps/CppsRoundActions.vue')
  },
  {
    path: '/cpps/schedule',
    name: 'CppsGenerateSchedule',
    component: () => import('../views/cpps/CppsGenerateSchedule.vue')
  },
  {
    path: '/custom-schedule',
    name: 'CustomSchedule',
    component: () => import('../views/CustomSchedule.vue')
  },
  {
    path: '/cpps/custom-schedule',
    redirect: '/custom-schedule'
  },
  {
    path: '/cpps/podium-print',
    name: 'CppsPodiumPrint',
    component: () => import('../views/cpps/PrintablePodium.vue')
  },
  {
    path: '/cpps/logs',
    name: 'CppsLogViewer',
    component: () => import('../views/cpps/CppsLogViewer.vue')
  },
]

const PUBLIC_ROUTES = ['/home'];

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? "/" : "",
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = store.state.auth.status.loggedIn;
  if (!PUBLIC_ROUTES.includes(to.path) && !loggedIn) {
    return next('/home');
  }
  next();
});

export default router
